import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { PaymentModeAdapter } from './dto/payment-mode.adapter';
import { PaymentMode } from './payment-mode.entity';
import { PaymentModeController } from './payment-mode.controller';
import { PaymentModeService } from './payment-mode.service';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { LogsService } from '@gtpl/shared-services/user-logs';

@Module({
  imports: [
  TypeOrmModule.forFeature([PaymentMode]),
  ],
  controllers: [PaymentModeController],
  providers: [PaymentModeService,PaymentModeAdapter,ApplicationExceptionHandler,LogsService]
})
export class PaymentModeModule {


  
}